import React from "react";
import logoMombasa from "../../../core/img/branch-logos/logo_mombasa.jpg";
import logoNairobi from "../../../core/img/branch-logos/logo_nairobi.jpg";
import logoSystems from "../../../core/img/branch-logos/logo_systems.jpg";
import logoTexastrack from "../../../core/img/branch-logos/logo_texastrack.png";

// Same 4 branch-logo assets + MOMBASA-default fallback as StockDocumentPreview.jsx
// (LPO/Stock/Quotation prints) - kept as a local copy rather than importing from
// the stock module, since that component's own logoUrlFor is not exported and
// the Leave module shouldn't reach across features for one small helper.
const LOGO_BY_BRANCH_CODE = {
  MOMBASA: logoMombasa,
  NAIROBI: logoNairobi,
  SYSTEMS: logoSystems,
  TEXASTRACK: logoTexastrack,
};

// Print popup is a bare window.open("", "_blank") with no real page URL, so a
// webpack-emitted root-relative logo path won't resolve there - always
// resolve to a full absolute URL, same reasoning as StockDocumentPreview.jsx.
const logoUrlFor = (branchCode) => new URL(LOGO_BY_BRANCH_CODE[branchCode] || logoMombasa, window.location.origin).href;

const FONT_FAMILY = '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

// One "EMPLOYEE LEAVE FORM" slip - modeled directly on the legacy paper form
// (Working_Files reference photo, 2026-09-07): logo, boxed title, Emp Code/
// Emp Name/Designation/For The Year, Proceeding From/Reporting Back On, then
// Approved By / Employee Signature lines. A fixed height (not flowed) so two
// of these stack predictably onto one A4 page - see LeaveFormPrintModal.jsx.
const LeaveFormPrint = ({ branchCode, empCode, empName, empLastName, designationName, year, fromDate, toDate }) => (
  <div
    style={{
      fontFamily: FONT_FAMILY,
      fontSize: 12,
      lineHeight: 1.4,
      color: "#000",
      background: "#fff",
      border: "1px solid #000",
      padding: "10mm 12mm",
      height: "128mm",
      boxSizing: "border-box",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}>
      <img src={logoUrlFor(branchCode)} alt="Texas Alarms" style={{ height: 70 }} />
    </div>

    <div
      style={{
        textAlign: "center",
        border: "1px solid #000",
        borderRadius: 6,
        padding: "4px 0",
        fontWeight: 700,
        fontSize: 14,
        letterSpacing: 0.5,
        marginBottom: 16,
      }}
    >
      EMPLOYEE LEAVE FORM
    </div>

    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <tbody>
        <tr>
          <td style={{ padding: "4px 0", width: "38%", fontWeight: 600 }}>Emp Code</td>
          <td style={{ padding: "4px 0" }}>: &nbsp; {empCode}</td>
        </tr>
        <tr>
          <td style={{ padding: "4px 0", fontWeight: 600 }}>Emp Name</td>
          <td style={{ padding: "4px 0" }}>
            : &nbsp; {empName} {empLastName}
          </td>
        </tr>
        <tr>
          <td style={{ padding: "4px 0", fontWeight: 600 }}>Designation</td>
          <td style={{ padding: "4px 0" }}>: &nbsp; {designationName || "-"}</td>
        </tr>
        <tr>
          <td style={{ padding: "4px 0", fontWeight: 600 }}>For The Year</td>
          <td style={{ padding: "4px 0" }}>: &nbsp; {year}</td>
        </tr>
        <tr>
          <td style={{ padding: "4px 0", fontWeight: 600 }}>Proceeding From</td>
          <td style={{ padding: "4px 0" }}>
            : &nbsp; {fromDate} to {toDate}
          </td>
        </tr>
        <tr>
          <td style={{ padding: "4px 0", fontWeight: 600 }}>Reporting Back On</td>
          <td style={{ padding: "4px 0" }}>: &nbsp; {toDate}</td>
        </tr>
      </tbody>
    </table>

    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 26 }}>
      <tbody>
        <tr>
          <td style={{ width: "50%", verticalAlign: "bottom" }}>
            <div style={{ borderBottom: "1px solid #000", height: 30 }} />
            <div style={{ marginTop: 4 }}>Approved By</div>
          </td>
          <td style={{ width: "50%", verticalAlign: "bottom", paddingLeft: 16 }}>
            <div style={{ borderBottom: "1px solid #000", height: 30 }} />
            <div style={{ marginTop: 4 }}>Employee Signature</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default LeaveFormPrint;
